import { toast } from "react-toastify";
import { carRentalErrorMsgs } from "../../../errors";
import { carRentalPreBook } from "../../../api/carRental";
import * as yup from "yup";
import { sendPixelEvent } from "../../../helpers";
import { getExchangedPrice } from "../../../umbilical_hocs";
import { paymentDispatcher } from "../../../actions/book/payment";
import React from "react";

export async function onCarRentalPreBook({
  carRental,
  search_session_id,
  onCancel,
  onPrebookData,
  market_type,
  source_entity,
  t,
}) {
  var payload = {
    session_id: search_session_id,
    supplier: "carnect",
    booking_id: carRental.booking_id,
    source_entity,
    market_type,
  };

  const result = await carRentalPreBook(payload);
  if (!result) {
    toast.warning(carRentalErrorMsgs(t).detailView.no_availability, {
      duration: 3000,
    });
    onCancel();
    return null;
  }
  await onPrebookData({
    key: "prebooked_result",
    value: { ...result.prebooked_result },
  });

  return result;
}

const schema = (t) => {
  return yup.object().shape({
    title: yup.string().required(t("titleIsRequired")),
    gender: yup.string().required(t("genderIsRequired")),
    date_of_birth: yup.array().of(yup.date().required()),
    first_name: yup
      .string()
      .matches(/^[A-Za-z ]+$/, {
        message: t("firstNameMustContainAlphabetic"),
        excludeEmptyString: true, // This prevents displaying the error for empty strings
      })
      .required(t("firstNameIsRequired")),
    last_name: yup
      .string()
      .matches(/^[A-Za-z ]+$/, {
        message: t("lastNameMustContainAlphabetic"),
        excludeEmptyString: true,
      })
      .required(t("lastNameIsRequired")),
    phone: yup
      .string()
      .matches(/^\+\d{1,3}\d{10}$/, {
        message: `${t(
          "phoneNumberInTheFormat"
        )}: +[country code][phone number] (e.g. +447123456789)`,
        excludeEmptyString: true,
      })
      .required(t("phoneNumberIsRequired")),
    email: yup
      .string()
      .required(t("emailIsRequired"))
      .test("valid-email", t("invalidEmail"), (value) => {
        // Use a regular expression to check if the email includes "@" and a domain
        const regex = /@.*\..+/;
        return value.length === 0 ? true : regex.test(value);
      }),
    address: yup.string().required(t("addressIsRequired")),
    city: yup.string().required(t("cityIsRequired")),
    postal_code: yup.string().required(t("postalCodeIsRequired")),
    country: yup.string().required(t("countryIsRequired")),
  });
};

export async function validateCarRentalDriverData(values, t) {
  return await schema(t)
    .validate(values, { abortEarly: false })
    .then(() => true)
    .catch((error) => {
      toast.error(
        <ul>
          {error.inner.map((err, idx) => (
            <li key={idx}>{err.message}</li>
          ))}
        </ul>,
        {
          duration: 3000,
        }
      );
      return false;
    });
}

export async function initPayment({ payload, dispatch }) {
  const validationSchema = yup.object().shape({
    customer_user_data: yup.object().shape({
      first_name: yup.string().required(),
      last_name: yup.string().required(),
      email: yup.string().email().required(),
      customer_uid: yup.string(),
      // customer_stripe_id: yup.string().nullable(),
    }),
    page_session_id: yup.string().required(),
    settedCurrency: yup.string().required(),
    amount: yup.number().required().moreThan(0),
    currency: yup.string().required(),
    reference: yup.string().required(),
  });

  try {
    await validationSchema.validate(payload, { abortEarly: false });
  } catch (error) {
    return false;
  }

  const newPrice = getExchangedPrice({
    price: payload.amount,
    priceCurrency: payload.currency,
    settedCurrency: payload.settedCurrency,
  });

  // const data = window.btoa(JSON.stringify(selectionData));

  const booking_reference = payload.reference;
  const srv_type = "CAR";
  const order_id = `${srv_type}___${booking_reference}`;

  const base_url = window.location.origin;
  const success_url = `${base_url}/car-rental/successful-booking/${payload.page_session_id}`;
  const cancel_url = `${base_url}/car-rentals/booking_process/${payload.page_session_id}`;
  const fail_url = `${base_url}/failed-booking/${payload.page_session_id}`;

  sendPixelEvent("InitiateCheckout", {
    data: { product_type: "car_rental" },
    withPageView: false,
  });

  const {
    first_name,
    last_name,
    guest_uuid: customer_uid,
    nationality,
    email,
    customer_stripe_id,
  } = payload.customer_user_data;

  dispatch(
    paymentDispatcher({
      booking_reference,
      source_entity: payload.source_entity,
      page_session_id: payload.page_session_id,
      amount: newPrice,
      currency: payload.settedCurrency,
      first_name,
      last_name,
      email,
      customer_uid,
      nationality,
      customer_stripe_id,
      order_id,
      success_url,
      cancel_url,
      fail_url,
      srv_type,
    })
  );
  return true;
}
